export const brandToCaseMap = {
  seek: 'SEEK',
  jobsdb: 'Jobsdb',
  jobstreet: 'Jobstreet',
} as const;

export const poeaTerms = ['poea', 'overseas', 'dmw', 'abroad'];

export const CAREER_FEED_AI_ASSISTANT_CHAT_CONTEXT_COOKIE_NAME =
  'candidateChatContext';
